const theme = {
  colors: {
    lightGrayBorder: "#d6d8d9",
    darkText: "#253441",
    green: "#63A861",
    lightBlue: "#eef0f1",
    danger: "#d32f2f",
    textLight: "#666",
    lightDanger: "#fdecea",
    info: "#2f6fed",
    lightInfo: "#eef5ff",
  },
  standardRadius: "7px",
};

export default theme;
